<template>
  <el-dialog
    title="物料选择"
    v-model="visible"
    :close-on-click-modal="false"
    width="70%"
  >
    <el-form :model="searchData" :inline="true" ref="searchRef">
      <el-form-item label="物料名称：" prop="name">
        <el-input v-model="searchData.name" placeholder="请输入物料名称" />
      </el-form-item>
      <el-form-item label="类别：" prop="categoryId">
        <el-tree-select
          v-model="searchData.categoryId"
          :data="categoryList"
          node-key="id"
          :props="defaultProps"
          :expand-on-click-node="false"
        />
      </el-form-item>
      <el-form-item>
        <el-button type="primary" icon="Search" @click="getList()"
          >查询</el-button
        >
        <el-button icon="Refresh" @click="handleReset()">重置</el-button>
        <el-button type="danger" icon="Delete" @click="handleClean()"
          >清空选中</el-button
        >
      </el-form-item>
    </el-form>
    <el-table
      :header-cell-style="{ 'text-align': 'center' }"
      :cell-style="{ 'text-align': 'center' }"
      v-loading="loading"
      :data="tableData"
      ref="tableRef"
      @selection-change="handleSelectionChange"
      :row-key="props.type == 'in' ? 'id' : 'quantityId'"
      @select="handleSelect"
      @select-all="handleSelectAll"
    >
      <el-table-column
        type="selection"
        width="55"
        :reserve-selection="true"
        :selectable="selectable"
      />
      <template v-for="item in columns" :key="item.prop">
        <el-table-column
          :label="item.label"
          :prop="item.prop"
          show-overflow-tooltip
          v-if="item.show ?? true"
        >
          <template #default="{ row }">
            <el-tag
              v-if="item.prop == 'checkStatus' && props.type == 'out'"
              :type="row[item.prop]?.value == 1 ? 'danger' : ''"
              >{{ row[item.prop]?.value == 1 ? "是" : "否" }}</el-tag
            >
            <el-tag
              v-else-if="item.prop == 'inventoryNumber' && row[item.prop] == 0"
              type="danger"
              >{{ row[item.prop] }}</el-tag
            >
            <span v-else-if="item.prop == 'name' && props.type == 'out'">
              {{ row[item.prop] }}
            </span>
          </template>
        </el-table-column>
      </template>
    </el-table>
    <el-pagination
      v-if="pages.total > 0"
      class="mt10"
      :total="pages.total"
      layout="->, prev, pager, next"
      v-model:current-page="pages.page"
      @update:current-page="getList"
    />
    <template #footer>
      <span class="dialog-footer">
        <el-button @click="visible = false">取消</el-button>
        <el-button type="primary" @click="handleSelectionComplete()">
          确定
        </el-button>
      </span>
    </template>
  </el-dialog>
</template>

<script setup>
import { reactive, ref } from "vue";
import { queryMaterielList } from "@/api/materiel";
import { queryStorageTable } from "@/api/inventory";
import { queryTable } from "@/api/inventory";
import useCateGoryList from "@/views/hooks/useCategoryList";
import { ElMessage } from "element-plus";

const emits = defineEmits(["selectDone"]);

const { categoryList } = useCateGoryList();

/**
 * 入库时选择的数据来自于 <物料管理>
 * 出库时选择的数据来自于 <库存管理>
 */
const props = defineProps({
  // api类型
  type: {
    type: String,
    default: "in",
  },
  // 是否校验数量为0的数据
  validateZero: {
    type: Boolean,
    default: true,
  },
});

const defaultProps = {
  label: "node",
};

// 弹窗控制
const visible = ref(false);

// 搜索表单ref
const searchRef = ref(null);

// 表格的ref
const tableRef = ref(null);

// 搜索条件
const searchData = reactive({
  name: null,
  categoryId: null,
  warehouseId: null,
  gtZero: true,
});

// 获取表格的数据
const fns = reactive({
  in: queryTable,
  out: queryTable,
});

// 表格列配置
const columns = ref([
  {
    label: "物料编号",
    prop: "number",
  },
  {
    label: "物料名称",
    prop: "name",
  },
  {
    label: "物料类别",
    prop: "categoryName",
  },
  {
    label: "品牌",
    prop: "brand",
  },
  {
    label: "规格型号",
    prop: "model",
  },
  {
    label: "单位",
    prop: "unit",
  },

  {
    label: "仓库",
    prop: "warehouseNameList",
  },
  {
    label: "库存数量",
    prop: "totalQuantity",
  },
  {
    label: "库存上限",
    prop: "upperLimit",
  },
  {
    label: "库存下限",
    prop: "lowerLimit",
  },
  {
    label: "库存单价",
    prop: "realTimeUnitPrice",
  },
]);

// 表格遮罩
const loading = ref(false);

// 表格数据
const tableData = ref([]);

// 父组件传进来的表格
const reserveTable = ref([]);

// 分页数据
const pages = reactive({
  page: 1,
  limit: 10,
  total: 0,
});

// 多选选中的数据
const multipleSelection = ref([]);

// 数据选中事件
const handleSelectionChange = (val) => {
  multipleSelection.value = [...val]; // 深拷贝
};

// 选中某一行的事件
const handleSelect = (selection, row) => {
  // if (props.type == "out") {
  //   // 判断物料是否盘点中
  //   if (row.checkStatus.value == "1") {
  //     ElMessage.error("该物料正在盘点中,不支持操作");
  //     tableRef.value?.toggleRowSelection(row, false);
  //     return;
  //   }
  //   // 库存为0无法出库
  //   if (row.inventoryNumber == 0 && props.validateZero) {
  //     ElMessage.error("库存不足，无法选择");
  //     tableRef.value?.toggleRowSelection(row, false);
  //   }
  // }
};

// 表格全选事件
const handleSelectAll = (selection) => {
  const arr = [].concat(selection);
  // // 判断物料是否盘点中
  // if (props.type == "out") {
  //   let count = 0;
  //   arr.forEach((item) => {
  //     if (
  //       item.checkStatus.value == "1" ||
  //       (item.inventoryNumber == 0 && props.validateZero)
  //     ) {
  //       count++;
  //       tableRef.value?.toggleRowSelection(item, false);
  //     }
  //   });
  //   if (count > 0) {
  //     ElMessage.warning(
  //       `已取消勾选全选状态下正在盘点中${
  //         props.validateZero ? "和库存不足" : ""
  //       }的物料`
  //     );
  //   }
  // }
};

// 清空所有选中
const handleClean = () => {
  tableRef.value?.clearSelection();
};

// 弹窗打开
const handleDialogOpen = (ids, warehouseId, gtZero) => {
  tableRef.value?.clearSelection();
  searchData.gtZero = gtZero;
  searchData.warehouseId = warehouseId || null;
  reserveTable.value = ids;
  getList();
  visible.value = true;
};

// 反选表格
const reserveSelect = () => {
  // 入库不用反选
  if (props.type == "out") {
    tableData.value.forEach((item) => {
      if (reserveTable.value.includes(item.quantityId)) {
        tableRef.value?.toggleRowSelection(item, true);
      }
    });
  }
};

// 获取数据
const getList = () => {
  loading.value = true;
  fns[props.type]({ ...searchData, page: pages.page })
    .then((res) => {
      tableData.value = res.data.records;
      pages.total = res.data.total;
    })
    .finally(() => {
      loading.value = false;
      reserveSelect();
    });
};

// 点击确定按钮
const handleSelectionComplete = () => {
  // 判断物料是否盘点中
  // if (props.type == "out") {
  //   multipleSelection.value = multipleSelection.value.filter(
  //     (item) => item.checkStatus.value != "1"
  //   );
  // }
  console.log(multipleSelection.value);
  emits("selectDone", multipleSelection.value);
  visible.value = false;
};

// 重置
const handleReset = () => {
  searchRef.value?.resetFields();
  getList();
};

// 决定哪些行可以选择
const selectable = (row, index) => {
  // if (props.type == "in") return true;
  return true;
};

defineExpose({
  handleDialogOpen,
});
</script>

<style scoped></style>
